var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            !_vm.hideFilters ||
            _vm.hasVisibleWidgets ||
            _vm.hasRelocatedContent,
          expression:
            "!hideFilters || hasVisibleWidgets || hasRelocatedContent",
        },
      ],
      staticClass: "filterContainer",
    },
    [
      !_vm.filtersOnly &&
      this.displayActionCodeInput &&
      !_vm.$store.state.pointshop
        ? _c("actionCodeInput", { staticClass: "hideInMobile" })
        : _vm._e(),
      !_vm.filtersOnly && this.$root.pointshop
        ? _c("pointShopWidget", { ref: "pointWidget" })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideFilters,
              expression: "!hideFilters",
            },
          ],
          staticClass: "categoryContainer",
        },
        _vm._l(_vm.attrs, function (attr, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("transition", { attrs: { name: "btn-fade" } }, [
                _c(
                  "div",
                  {
                    class: [
                      _vm.hideCategories.includes(attr.attributeId)
                        ? "openCat"
                        : "",
                    ],
                  },
                  [
                    _c(
                      "p",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.hideShow(attr.attributeId)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(attr.attribute) + " "),
                        _vm.showCounts && _vm.checkedCount(attr) > 0
                          ? _c("span", { staticClass: "catFilterCount" }, [
                              _vm._v(_vm._s(_vm.checkedCount(attr))),
                            ])
                          : _vm._e(),
                        _c("i", {
                          class: _vm.hideCategories.includes(attr.attributeId)
                            ? "far fa-angle-right"
                            : "far fa-angle-down",
                        }),
                      ]
                    ),
                    _c("transition", { attrs: { name: "slide" } }, [
                      !_vm.hideCategories.includes(attr.attributeId)
                        ? _c("div", { staticClass: "categories" }, [
                            _c(
                              "ul",
                              _vm._l(attr.values, function (value, index2) {
                                return _c(
                                  "li",
                                  {
                                    key: index2,
                                    class: [value.checked ? "checked" : ""],
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: value.checked,
                                          expression: "value.checked",
                                        },
                                      ],
                                      attrs: {
                                        id: value.attributeValueId,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(value.checked)
                                          ? _vm._i(value.checked, null) > -1
                                          : value.checked,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = value.checked,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    value,
                                                    "checked",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    value,
                                                    "checked",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(value, "checked", $$c)
                                            }
                                          },
                                          function ($event) {
                                            return _vm.submitChangeToFilter(
                                              value,
                                              value.checked
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: value.attributeValueId },
                                      },
                                      [_vm._v(_vm._s(value.name))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
      !_vm.filtersOnly &&
      !_vm.hideFilters &&
      this.$root.language.wsm_legalInfoHeading != "false"
        ? _c("div", { staticClass: "legalInfoContainer" }, [
            _c("p", {
              staticClass: "legalInfoHeading",
              domProps: {
                innerHTML: _vm._s(this.$root.language.wsm_legalInfoHeading),
              },
            }),
            _c("p", {
              staticClass: "legalInfoBody",
              domProps: {
                innerHTML: _vm._s(this.$root.language.wsm_legalInfoBody),
              },
            }),
          ])
        : _vm._e(),
      !_vm.filtersOnly
        ? _c("div", {
            ref: "relocatedLeftBox",
            staticClass: "relocatedLeftBox",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }